import { createContext, useContext } from "react";
import { useAudioPlayer } from "../hooks/useAudioPlayer";
import { useTracks } from "../hooks/useTracks";

export const FALLBACK_TRACKS = [
  {
    id: "track-1",
    title: "Golden Anniversary Ballad",
    style: "Acoustic Pop",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    lyrics: "Fifty years of mornings, coffee side by side\nEvery wrinkle tells a story we survived\nGolden is the promise that we made back then\nAnd I'd say yes, my love, again and again",
  },
  {
    id: "track-2",
    title: "Swiss Alpine Jingle",
    style: "Radio Jingle",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
    lyrics: "From the peaks down to the lake\nFresh as the morning, wide awake\nAlpenfrisch, the taste you know\nSwitzerland in every note",
  },
  {
    id: "track-3",
    title: "Wedding Vows Pop Anthem",
    style: "Pop",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
    lyrics: "Underneath the lights we stand\nYour forever in my hand\nEvery heartbeat says your name\nNothing in this world the same",
  },
  {
    id: "track-4",
    title: "Corporate Tech Beat",
    style: "Corporate",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
    lyrics: "Innovation on the rise\nData streams and open skies\nWe build tomorrow, line by line\nYour vision, engineered to shine",
  },
  {
    id: "track-5",
    title: "Acoustic Birthday Serenade",
    style: "Acoustic",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3",
    lyrics: "Another candle, another year\nGather close, the ones you hold dear\nThis little song was made for you\nHappy birthday, through and through",
  },
  {
    id: "track-6",
    title: "Lounge Jazz Album Track",
    style: "Jazz",
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3",
    lyrics: "Velvet evening, city glow\nSaxophone is playing low\nTake my hand and take it slow\nThere's nowhere else we need to go",
  },
];

const PlayerContext = createContext(null);

export const usePlayer = () => useContext(PlayerContext);

export function PlayerProvider({ children }) {
  const tracks = useTracks(FALLBACK_TRACKS);
  const value = useAudioPlayer(tracks);
  return <PlayerContext.Provider value={value}>{children}</PlayerContext.Provider>;
}
